var _polygon, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHoldZero = function SvgHoldZero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9.25 9.5 9.26105 9.50085 10 10.57385 10.73706 9.50085 10.75 9.5 10.74908 9.48383 13.79291 5.05688 12.55688 4.20709 10.74908 6.83588 10.75 0 9.25 0 9.24908 6.83588 7.44312 4.20709 6.20709 5.05688 9.24908 9.48383 9.25 9.5",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12.5,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.75,
    cy: 12.5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 12.5,
    r: 1.5
  })));
};

export default SvgHoldZero;